var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#address_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.93 15.89.07.07.07-.07 4.243-4.243a6.1 6.1 0 1 0-8.626 0l.07-.071-.07.07 4.242 4.243ZM8 13.791l-3.23-3.23a4.566 4.566 0 1 1 6.46 0L8 13.793ZM6.986 8.347A1.433 1.433 0 1 0 9.014 6.32a1.433 1.433 0 0 0-2.028 2.027Z",
    fill: "var(--native-icon-fill)",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "address_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--native-icon-secondary-fill)",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgAddress;